import { type UseGuidedAccessStateParams } from './useGuidedAccessModeEnabled.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * iOS only
 */
export function useGuidedAccessModeEnabled(
  _params?: UseGuidedAccessStateParams,
) {
  return false;
}
